import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"

import RtwImageAction from "store/rtw-image-resource/actions"

export default function DetailRtwImage() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      file: null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("RTW画像名 必須項目です。"),
      file: Yup.mixed().required("画像 必須項目です。"),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(RtwImageAction.postData(values, callbackPost))
      } else {
        dispatch(
          RtwImageAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  const callbackPost = () => {
    history.push("/master/rtw-handwritten-image")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/master/rtw-handwritten-image")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
    validation.setFieldValue("preview", data.imageUrl)
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(RtwImageAction.getDetail({ id: params.id }, callbackGetDetail))
    }
  }, [params.id])

  const onChangePicture = e => {
    if (e.target.files[0]) {
      const reader = new FileReader()
      reader.addEventListener("load", () => {
        validation.setFieldValue("file", e.target.files[0])
        validation.setFieldValue(
          "preview",
          URL.createObjectURL(e.target.files[0])
        )
      })
      reader.readAsDataURL(e.target.files[0])
    }
  }

  return (
    <>
      <MetaTags>
        <title>個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="RTW手書き画像マスター" breadcrumbList={[]} />

          <Card>
            <CardBody>
              {store.rtwProduct.detail.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "RTW手書き画像マスター詳細"
                          : "新規RTW手書き画像マスター追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <Button type="submit" className="button me-2">
                        保存
                      </Button>
                      <Button
                        type="button"
                        className="button"
                        onClick={() =>
                          history.push("/master/rtw-handwritten-image")
                        }
                      >
                        キャンセル
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2} className="col-form-label">
                      <label className="">RTW画像名</label>
                    </Col>
                    <Col md={10}>
                      <Input
                        name="name"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>

                  <Row>
                    <Col md={2}>
                      <label className="">画像</label>
                    </Col>
                    <Col md={10}>
                      <Input
                        className="form-control"
                        accept="image/*"
                        type="file"
                        onChange={onChangePicture}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Col md={2}></Col>
                    <Col md={10}>
                      <Col md="12">
                        <div className="w-100">
                          {validation?.values?.preview ? (
                            <img
                              style={{
                                height: "100%",
                                objectFit: "cover",
                              }}
                              className="w-100"
                              alt="file-upload"
                              src={validation?.values?.preview}
                            />
                          ) : (
                            <div
                              style={{
                                border: "1px solid #ced4da",
                                height: "500px",
                              }}
                              className="w-100 d-flex align-items-center justify-content-center rounded-1"
                            >
                              プレビュー
                            </div>
                          )}
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
